/* ================================================== */
/* MOBILE MENU → Open
/* ================================================== */

function openMenu() {

	// Set last focused element
	lastFocusedElement = document.activeElement;

	// Scroll top
	var page = $('html, body');
	page.on('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove', function() {
		page.stop()
	}).animate({ scrollTop: 0 }, 400);

	// Open menu
	$menu.addClass(openClass);
	$menuTrigger.addClass(activeClass.substr(1));

	// Enable focus on menu links
	$menu.find('a:not(.link--active), .link--menu').attr('tabindex', '0');

	// Add roles
	$menu.attr({
		'aria-hidden'  : 'false',
		'aria-expanded': 'true'
	});

	// Lock, hide and make unfocusable all other elements
	$('html, body').addClass('overflow-hidden');
	$('body').attr('data-menu', 'opened');
	$('body > *:not(.menu--trigger):not(#layout--menu):not(#layout--header)').find('a, button, details > summary, iframe').each(function(index, element) {
		var tabindex = $(element).attr('tabindex');
		if (typeof tabindex !== typeof undefined && tabindex !== false) {
			$(element).attr('data-initial-tabindex', tabindex);
		}

		$(element).attr('tabindex', '-1');
	});

	// Set focus on first menu element
	$('a', $menu).first().focus();

}